import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseApiTemplateService} from '../../shared';
import {FinancialConfigContainerModel} from '../../../../../../models/aggregates/erp/payment-configuration';
import {Core2Config} from '../../shared';


@Injectable({
  providedIn: 'root'
})
export class PaymentConfigurationService extends BaseApiTemplateService<FinancialConfigContainerModel> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'payment-config';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'payment-config';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'payment-config';
    this.httpClient = http;
  }

}


